import DeleteAccountResultComponent from './delete-account-result-dialog.component'

const DeleteAccountResultDialogModule = angular.module('cdbl.account-account-result-dialog', [

])
  .component('cdblDeleteAccountResultDialog', DeleteAccountResultComponent)
  .name

export default DeleteAccountResultDialogModule
